module.exports = __webpack_public_path__ + "img/dark-theme.13c1fa5c.png";